
const env = import.meta.env;


import { datadogLogs } from '@datadog/browser-logs';
import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";

const apiKey = env.VITE_FIREBASE_API_KEY;

function getAuthDomain() {
    return window.location.host;
}

if (!apiKey) {
    console.log(env);
    datadogLogs.logger.error('VITE_FIREBASE_API_KEY is not set in environment');
    throw new Error('VITE_FIREBASE_API_KEY is not set in environment');
}

const firebaseConfig: FirebaseOptions = {
    apiKey: apiKey,
    authDomain: getAuthDomain(),
    projectId: "dengenlabs",
    appId: "1:265888598630:web:6e5e76c8ecde887e5afba7",
};


const app = initializeApp(firebaseConfig);
console.log('Firebase app initialized', firebaseConfig);
datadogLogs.logger.info('Firebase app initialized', {
    vertesia: {
        firebase: {
            auth_domain: firebaseConfig.authDomain,
            project_id: firebaseConfig.projectId,
            app_id: firebaseConfig.appId,
        },
    },
});
export const firebaseAuth = getAuth(app);
